module.exports = __webpack_public_path__ + "static/img/1.750472c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/1.png
// module id = 5HXI
// module chunks = 1